// src/index.js
import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { UserProvider } from "./hooks/useUser";

window.Buffer = window.Buffer || Buffer;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </AuthProvider>
  </React.StrictMode>
);

// Limpeza agressiva de caches legados do PWA no cliente
if ("caches" in window) {
  caches.keys().then((keys) => {
    keys.forEach((key) => {
      if (key !== "gestao-timbo-v10") {
        console.log("[App] Purgando cache antigo:", key);
        caches.delete(key);
      }
    });
  });
}

// Registrar e forçar atualização do Service Worker (PWA)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("SW registrado com sucesso:", registration.scope);
        // Força checagem imediata se há nova versão no servidor
        registration.update();

        // Se houver um novo worker esperando, ativa imediatamente
        if (registration.waiting) {
          registration.waiting.postMessage({ action: "skipWaiting" });
        }
      })
      .catch((error) => {
        console.error("Falha ao registrar SW:", error);
      });

    // Quando o novo worker assume o controle, recarrega a página automaticamente
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!refreshing) {
        refreshing = true;
        console.log("[App] Nova versão instalada. Recarregando...");
        window.location.reload();
      }
    });
  });
}
